window.isTouchDevice = function () {
    return true == ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);
}

window.screen = function () {
    var state = 'click';
    if (isTouchDevice() === true) {
        state = 'touchstart';
    }
    return {
        h: jQuery(window).height(),
        w: jQuery(window).width(),
        scroll: jQuery(window).scrollTop(),
        pointerAction: state
    };
}

jQuery(document).ready(function ($) {
    $('a[href="#"]').click(function (e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    });

    $('.smoothScroll').on(screen().pointerAction, function (e) {
        e.preventDefault();
        var header = document.getElementsByTagName('header')[0].offsetHeight;
        var hh = $($(this).attr('href')).offset().top - header;
        $('html, body').animate({
            scrollTop: hh
        }, 300, 'linear');
    }); //smoothScroll


    jQuery('.content-wrap, aside').theiaStickySidebar({
        // Settings
        // additionalMarginTop: 30
        minWidth: 991
    });

    $('#aside-mob-toggle').on(screen().pointerAction, function(e) {
        e.preventDefault();
        var header = document.getElementsByTagName('header')[0].offsetHeight;
        var hh = $('aside').offset().top - header;
        $('html, body').animate({
            scrollTop: hh - 7
        }, 300, 'linear');
        setTimeout(function() {
            $('aside').toggleClass("open");
        }, 300);
    });

    var showPass=false;
    $('#hidden-reveal-checkbox').on('change', function(){
        showPass = ($('#hidden-reveal-checkbox:checked').length>0);
        if (showPass){
            $('#hide-by-checkbox').hide();
            $('#reveal-by-checkbox').show();
        }else{
            $('#reveal-by-checkbox').hide();
            $('#hide-by-checkbox').show();
        }
    });

    $('#hide-by-checkbox').on('change', function(){
        if (!showPass) $('#reveal-by-checkbox').val($('#hide-by-checkbox').val());
    });
    $('#reveal-by-checkbox').on('change', function(){
        if (showPass) $('#hide-by-checkbox').val($('#reveal-by-checkbox').val());
    });

});

$(document).on("tap click", 'label a', function( event, data ){
    event.stopPropagation();
    event.preventDefault();
    window.open($(this).attr('href'), $(this).attr('target'));
    return false;
});
